module.exports = {"id":"%{id}","title":"%{title}","state":"%{state}","type":"discount","displayCondition":{"type":"order_platform","platform":"callcenter"},"condition":{"type":"order_platform","platform":"callcenter"},"operator":{"type":"max","operators":[{"type":"multiply","numerators":[{"type":"sum_prices","items":"%{applyTo}"},{"type":"value","value":-1}]},{"type":"min","operators":[{"type":"value","value":0},{"type":"sum_prices","charges":{"ids":["%{id}"]}}]}]}}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/ChargeV2.template.discount.callcenter.json
// module id = 1120
// module chunks = 0